import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AutoLoginForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const username = localStorage.getItem("useremailidis");
    const password = localStorage.getItem("userpasswordis");
    const courseCount = localStorage.getItem("courseCount");

    if (username && password && courseCount && parseInt(courseCount) !== 0) {
      const loginForm = document.createElement("form");
      loginForm.action = `${import.meta.env.VITE_LMS_URL}/login/index.php`;
      loginForm.method = "POST";
      loginForm.style.display = "none"; // Hide the form

      const usernameInput = document.createElement("input");
      usernameInput.type = "hidden";
      usernameInput.name = "username";
      usernameInput.value = username;

      const passwordInput = document.createElement("input");
      passwordInput.type = "hidden";
      passwordInput.name = "password";
      passwordInput.value = password;

      loginForm.appendChild(usernameInput);
      loginForm.appendChild(passwordInput);

      document.body.appendChild(loginForm);

      setTimeout(() => {
        loginForm.submit();
      }, 500);
    } else {
      console.error("Error: No username, password, or invalid courseCount found in localStorage.");
      setIsLoading(false);
      navigate('/home/login');
    }
  }, [navigate]);

  return (
    <>
      {isLoading && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#030B11",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
        }}>
          <div style={{
            width: "48px",
            height: "48px",
            border: "3px solid #39FFFB",
            borderRadius: "50%",
            display: "inline-block",
            position: "relative",
            boxSizing: "border-box",
            animation: "rotation 1s linear infinite",
          }} />
        </div>
      )}
      <style>
        {`
          @keyframes rotation {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default AutoLoginForm;
